import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-popover-alert',
  templateUrl: './popover-alert.component.html',
  styleUrls: ['./popover-alert.component.scss'],
})
export class PopoverAlertComponent implements OnInit {
  @Input() text = 'text';
  @Input() isLoader = false;
  @Input() isError = false;
  @Input() isClick = false;
  @Input() textClick= '';
  @Output() IsClicked = new EventEmitter<string>();
  constructor(
    public dialogRef: MatDialogRef<PopoverAlertComponent>,
    @Inject(MAT_DIALOG_DATA)
    public options: {
      text: string;
      isLoader: boolean;
      isError: boolean;
      isClick: boolean;
      textClick: string;
    }
  ) {
    this.text = options.text;
    this.isError = options.isError;
    this.isLoader = options.isLoader;
    this.isClick= options.isClick;
    this.textClick= options.textClick;
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }

  onClick($event): void {
    this.IsClicked.emit($event);
  }

  confirm($event): void {
    this.dialogRef.close($event);
  }
}
